import { Box, Button, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import { withTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import keycloak from '../../keycloak'

const NotFoundPage = () => {
    const theme = useTheme()
    const navigate = useNavigate()
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'))

    return (
        <>
            <Grid
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
                sx={{
                    padding: '5px',
                }}
            >
                <Box
                    sx={{
                        mt: 1,
                        backgroundColor: 'white',
                        padding: '25px',
                        borderRadius: '5px',
                    }}
                    minWidth={matchUpMd ? '850px' : '455px'}
                    maxWidth={matchUpMd ? '850px' : '455px'}
                >
                    <Typography
                        variant="h5"
                        component="div"
                        gutterBottom
                        sx={{ textAlign: 'center' }}
                    >
                        {/* Page Not Found */}
                        Opps...
                    </Typography>

                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        component="div"
                        sx={{ textAlign: 'center' }}
                    >
                        The page you are going to visit is still developing, Please be patient.
                    </Typography>

                    <Button variant="contained" onClick={() => navigate(-1)}>
                        Back
                    </Button>
                </Box>
            </Grid>
        </>
    )
}

export default withTranslation()(NotFoundPage)
